import React from 'react';
import "./styles.css";
import { Link, useLocation } from 'react-router-dom';
import { homeTranslations } from '../i18n/home';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, getLanguageCookie } from '../utils/language';
import logo from '../media/logo.webp';
import perfectTimingLogo from '../media/perfect-timing-logo.jpeg';

export default function IndexPage() {
    const location = useLocation()
    const [activeLanguage, setActiveLanguage] = React.useState(DEFAULT_LANGUAGE)

    React.useEffect(() => {
        const [, maybeLang] = location.pathname.split('/')

        if (SUPPORTED_LANGUAGES.includes(maybeLang)) {
            setActiveLanguage(maybeLang)
            return
        }

        const cookieLang = getLanguageCookie()
        if (cookieLang && SUPPORTED_LANGUAGES.includes(cookieLang)) {
            setActiveLanguage(cookieLang)
            return
        }

        setActiveLanguage(DEFAULT_LANGUAGE)
    }, [location.pathname])

    const labels = homeTranslations[activeLanguage] || homeTranslations[DEFAULT_LANGUAGE]

    const showCopyright = ['/', '/en', '/sw', '/so'].includes(location.pathname)
    const signupStartPath = `${location.pathname || '/'}?flow=language`

    return (
        <div className="index-page relative min-h-screen w-full overflow-hidden bg-gradient-to-br from-red-950 via-black to-amber-900 text-white font-league-spartan">
            <div
                className="index-background pointer-events-none absolute inset-0"
                aria-hidden="true"
                style={{ backgroundImage: `url(${logo})` }}
            />
            <div className="index-glow pointer-events-none absolute inset-0 opacity-40">
                <div className="absolute -top-24 -left-20 h-80 w-80 rounded-full bg-red-500 blur-3xl"></div>
                <div className="absolute bottom-[-6rem] right-[-4rem] h-96 w-96 rounded-full bg-amber-500 blur-3xl"></div>
            </div>

            <div className="relative z-10 flex min-h-screen flex-col">
                <main className="relative mx-auto flex w-full max-w-4xl flex-1 flex-col items-center justify-center px-6 py-12 text-center">
                    <section className="flex w-full flex-col items-center gap-8 rounded-[2rem] border border-white/10 bg-black/35 px-6 py-12 shadow-[0_25px_90px_rgba(0,0,0,0.38)] backdrop-blur sm:px-10">
                        <img
                            src={perfectTimingLogo}
                            alt="Perfect Timing"
                            className="w-full max-w-xl rounded-3xl border border-amber-300/50 object-cover shadow-[0_0_45px_rgba(245,158,11,0.35)]"
                        />

                        <div className="flex w-full max-w-md flex-col gap-3 sm:flex-row sm:justify-center">
                            <Link
                                to={signupStartPath}
                                className="rounded-full border border-amber-300/70 bg-gradient-to-r from-red-500/90 via-red-700/90 to-black px-8 py-4 text-sm font-bold tracking-[0.2em] text-white shadow-[0_0_35px_rgba(153,27,27,0.35)] transition hover:-translate-y-0.5 hover:shadow-[0_0_45px_rgba(245,158,11,0.3)] sm:flex-1"
                            >
                                {labels.signup}
                            </Link>
                            <Link
                                to="/login"
                                className="rounded-full border border-white/25 bg-white/10 px-8 py-4 text-sm font-bold tracking-[0.2em] text-white transition hover:-translate-y-0.5 hover:bg-white/20 sm:flex-1"
                            >
                                {labels.login}
                            </Link>
                        </div>
                    </section>
                </main>

                {showCopyright && (
                    <footer className="px-6 pb-8 text-center text-[0.55rem] uppercase tracking-[0.2em] text-white/60">
                        Copyright © 2027
                    </footer>
                )}
            </div>
        </div>
    )
}
